import { Fragment } from 'react';
import type { JSX } from 'react';
import { renderNodes } from './tiptap/nodes.js';
import type { TipTapRenderOptions } from './tiptap/types.js';
import { decodeAnnouncementBody } from './utils/decodeYjsBody.js';

interface TipTapRenderProps {
  body: unknown;
  options: TipTapRenderOptions;
}

export function TipTapRender({ body, options }: TipTapRenderProps): JSX.Element {
  const doc = decodeAnnouncementBody(body);
  if (!doc) return <Fragment />;
  return <Fragment>{renderNodes(doc.content ?? [], options, 'root')}</Fragment>;
}
